import { compact } from "lodash-es";

export const buildAgentSearchableText = ({
  values,
}: {
  values: Array<string | null | undefined>;
}) => compact(values).join(" ").toLowerCase();
